// extracted by mini-css-extract-plugin
export var addressFields = "_ps-0";
export var animationContainer = "_ps-1";
export var footer = "_ps-2";
export var lineItems = "_ps-3";
export var modalContent = "_ps-4";
export var orderName = "_ps-5";
export var strong = "_ps-6";
export var warning = "_ps-7";